import { render, staticRenderFns } from "./App-settings.vue?vue&type=template&id=34679e5e&scoped=true"
import script from "./App-settings.vue?vue&type=script&lang=js"
export * from "./App-settings.vue?vue&type=script&lang=js"
import style0 from "./App-settings.vue?vue&type=style&index=0&id=34679e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34679e5e",
  null
  
)

export default component.exports